import React from 'react';
import config from './Modal.config';
import placeholder from './assets/placeholder.png';
import './Modal.less';

const Modal = ({ onClose, title, description, image }) => (
  <div className="modal-display">
    <div className="modal-wrapper">
      <div className="modal-content set-center">
        <h1 className="title-text" id="text_titleModal">
          {title}
        </h1>
        <p id="text_descModal">{description}</p>
        <img
          src={typeof image === 'string' ? image : placeholder}
          className="modal-image"
          alt="modalImage"
        />
        <button
          id="btn_closeModal"
          type="button"
          onClick={onClose}
          className="primary"
        >
          OK
        </button>
      </div>
    </div>
  </div>
);

Modal.propTypes = config.propTypes;
Modal.defaultProps = config.defaultProps;
Modal.componentDetail = config.componentDetail;
Modal.builderConfig = config.builderConfig;

export default Modal;
